import { render } from "./birthday.vue?vue&type=template&id=5cf61083&scoped=true&ts=true"
import script from "./birthday.vue?vue&type=script&lang=ts"
export * from "./birthday.vue?vue&type=script&lang=ts"

import "./birthday.vue?vue&type=style&index=0&id=5cf61083&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf61083"],['__file',"src/components/inputs/birthday.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cf61083"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cf61083', __exports__)) {
    api.reload('5cf61083', __exports__)
  }
  
  module.hot.accept("./birthday.vue?vue&type=template&id=5cf61083&scoped=true&ts=true", () => {
    api.rerender('5cf61083', render)
  })

}


export default __exports__